import request from "@/utils/request";

export function getList(params) {
  return request({
    url: "/CheckOutManagement/GetGroupWithPaging",
    method: "get",
    params
  });
}
export function changeBed(data) {
  return request({
    url: "/HostelDiagram/ExchangeBedState",
    method: "post",
    data
  });
}
export function confirm(data) {
  return request({
    url: "/CheckOutManagement/Confirm",
    method: "post",
    data
  });
}
